import { ServicesGroup } from "utils/helpers/ServicesGroup"

export function getDefaultServiceGroup({
    lastUsed,
    fromSurvey,
    defaultGroup,
    bookingAvailable,
}: {
    lastUsed?: ServicesGroup
    fromSurvey?: ServicesGroup
    defaultGroup?: ServicesGroup
    bookingAvailable: boolean
}) {
    if (
        lastUsed &&
        (bookingAvailable ? lastUsed.availableStatus.ok : lastUsed.availableStatusWithCompany.ok)
    )
        return lastUsed
    if (
        fromSurvey &&
        (bookingAvailable
            ? fromSurvey.availableStatus.ok
            : fromSurvey.availableStatusWithCompany.ok)
    )
        return fromSurvey
    return defaultGroup
}
